import Swiper from 'swiper/js/swiper.js';
import debounce from 'lodash/debounce';
import 'core-js/es/object/assign';

class Slider {
    constructor($slider, options) {
        if (!$slider)
            return;

        const defaults = {
            init: false,
            watchOverflow: true,
            keyboard: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            a11y: {
                'prevSlideMessage': 'Poprzedni slajd',
                'nextSlideMessage': 'Następny slajd',
                'firstSlideMessage': 'To jest pierwszy slajd',
                'lastSlideMessage': 'To jest ostatni slajd',
                'paginationBulletMessage': 'Idź do slajdu numer {{index}}'
            },
            on: {
                transitionStart: this.markVisible.bind(this)
            },
            // wrapperClass: 'slides',
            // slideClass: 'slide'
        };

        this.params = Object.assign(defaults, options);

        this.$slider = $slider;

        this.init();
        this.resize();

        window.addEventListener('resize', debounce(this.resize.bind(this), 300));
        window.addEventListener('load', this.forceResize.bind(this), false);
    }

    forceResize() {
        let event = document.createEvent('HTMLEvents');

        event.initEvent('resize', true, false);
        document.dispatchEvent(event);
    }

    init() {
        if (this.params.navigation === true) {
            this.params.navigation = {
                nextEl: '.arrow-next',
                prevEl: '.arrow-prev',
            };

            this.$slider.insertAdjacentHTML('afterbegin', `<div class="slider-navigation hidden">
                <button class="arrow-prev" aria-controls="" aria-label="poprzedni"></button>
                <button class="arrow-next" aria-controls="" aria-label="następny"></button>
            </div>`);
        }
        if (this.params.navigation) {
            this.$nav = this.$slider.querySelector('.slider-navigation');
        }
    }

    markVisible() {
        let lastVisible, firstVisible;

        if (this.slider.isEnd){
            lastVisible = this.slider.slides.length;
            firstVisible = lastVisible - this.visibleCount;
        } else {
            lastVisible = this.slider.activeIndex + this.visibleCount - 1;
            firstVisible = this.slider.activeIndex;
        }

        [...this.slider.slides].forEach((el, i) => {
            if (i < firstVisible || i > lastVisible) {
                el.classList.remove('slide-visible');
            } else {
                el.classList.add('slide-visible');
            }
        });

    }

    resize() {
        this.setVisibleCount();

        if (this.visibleCount === 0 && this.slider) {
            this.slider.destroy();
            this.slider = null;
            if (this.$nav) this.$nav.classList.add('hidden');
        } else if (this.visibleCount !== 0 && !this.slider) {
            this.slider = new Swiper(this.$slider, this.params);
            this.slider.init();
            this.markVisible();
            if (this.$nav) this.$nav.classList.remove('hidden');
        }
    }

    setVisibleCount() {
        this.visibleCount = this.params.slidesPerView;

        if (this.params.breakpoints) {
            for (let b in this.params.breakpoints) {
                if (this.params.breakpoints.hasOwnProperty(b) && b <= window.innerWidth) {
                    if (this.params.breakpoints[b].disable) {
                        this.visibleCount = 0;
                    } else {
                        this.visibleCount = this.params.breakpoints[b].slidesPerView;
                    }
            	}
            }
        }

        this.visibleCount = Math.floor(this.visibleCount);
    }
}

export default Slider;
